<template>
    <div :class="view_class_view.div_container" class="view_class_view_container">

		<lable for="select-elements" :class="view_class_view.label" >{{text_select}}</lable>
        <!-- Select para elegir elements -->
        <select id="select-elements" v-model="selectElements" v-on:change="addElement()" :class="view_class_view.select" >
            <option v-for="(option, i) in options_list.options" :key="i" :value="option.value">{{ option.text }}</option>
        </select>

		<lable for="select-elements" :class="view_class_view.label" >{{text_list}}</lable>
        <!-- listdo de elements seleccionados -->
        <ul id="list-elements" :class="view_class_view.list">
			<li v-for="(value, i) in listElements.selected" :key="i" :class="colorOptions[i]" class="list_li"> {{ value }} <button :id="'btn-delete-element-'+i" class="btn-delete-element" @click="deleteElement(i)"><strong>X</strong></button></li>
		</ul>
    </div>
</template>

<script>
import { ref, computed } from 'vue';
export default {
	props: {
		colors_options: {
			type: Array,
			default(){
				return [
					"bg-white text-black",
					"bg-white text-black"
				];
			}
		},
		options_list: {
			type: Object,
			default(){
				return {
					options: [],
					selected: []
				}
			}
		},
		view_class_view: {
			type: Object,
			default(){
				return {
					label: "",
					select: "",
					div_container: "",
					list: ""
				}
			}
		},
		text_select: {
			type: String,
			default(){
				return ""
			}
		},
		text_list: {
			type: String,
			default(){
				return ""
			}
		}
	},
	setup(props){
		let selectElements = ref("");
		let listElements = ref(props.options_list);
		let colorOptions = computed(()=> {
			let colors = [];
			let alt = 0;
			
			for (let index = 0; index < listElements.value.selected.length; index++) {
				colors.push(props.colors_options[alt])
				alt = alt>0? alt-1: alt+1;
			}
			return colors;
		});
		function addElement() {
			const value = selectElements.value;
			if(existElement(value)) return;
			listElements.value.selected.unshift(value);
			selectElements.value = "";
		}
		function deleteElement(key) {
			listElements.value.selected.splice(key, 1);
		}
		function existElement(value){
			return listElements.value.selected.includes(value);
		}
		function execute_validation(){
			// console.log("listElements.value.selected: ", listElements.value.selected)
			return listElements.value.selected;
		}
		return {
			selectElements,
			listElements,
			addElement,
			deleteElement,
			existElement,
			colorOptions,
			execute_validation
		}
	}
}
		
		
		
</script>

<style scoped>
/* Estilo para el contenedor principal */
.view_class_view_container {
    width: 80%;
    max-width: 800px;
    background-color: white;
}
/* Estilo para el título del select */
label[for="select-elements"] {
    display: block;
    font-weight: bold;
    margin-bottom: 10px;
}
/* Estilo para el select */
select#select-elements {
    width: 100%;
    padding: 10px;
    border: 1.5px solid #ccc;
    background-color: #fff;
    font-size: 16px;
	margin-bottom: 2em;
}
/* Estilo para los elements de la lista */
ul#list-elements {
    list-style: none;
    margin-top: 20px;
}
ul#list-elements li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    border: 1.5px solid #ccc;
}
ul#list-elements li button.btn-delete-element {
    border: none;
    border-radius: 50%;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 23px;
}
ul#list-elements li button.btn-delete-element:hover {
    transform: scale(1.2);
}
</style>